var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSparkLineIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: "50%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59995 3.45736C8.5986 3.72972 8.53601 3.99889 8.41608 4.24808C8.29615 4.49727 8.12146 4.72112 7.90292 4.90564C7.44358 5.29149 6.84317 5.50553 6.22014 5.50553C5.59711 5.50553 4.99669 5.29149 4.53736 4.90564C4.31775 4.72189 4.14235 4.4982 4.02233 4.24884C3.90232 3.99947 3.84033 3.72991 3.84033 3.45736C3.84033 3.1848 3.90232 2.91524 4.02233 2.66588C4.14235 2.41651 4.31775 2.19282 4.53736 2.00908C4.99669 1.62322 5.59711 1.40918 6.22014 1.40918C6.84317 1.40918 7.44358 1.62322 7.90292 2.00908C8.12146 2.1936 8.29615 2.41744 8.41608 2.66663C8.53601 2.91582 8.5986 3.185 8.59995 3.45736V3.45736Z",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03271 7.92643C9.03113 8.24831 8.95715 8.56643 8.81542 8.86093C8.67368 9.15542 8.46723 9.41997 8.20895 9.63804C7.6661 10.094 6.95653 10.347 6.22021 10.347C5.4839 10.347 4.77433 10.094 4.23148 9.63804C3.97194 9.42089 3.76464 9.15652 3.62281 8.86182C3.48097 8.56711 3.40771 8.24854 3.40771 7.92643C3.40771 7.60432 3.48097 7.28575 3.62281 6.99105C3.76464 6.69634 3.97194 6.43198 4.23148 6.21483C4.77433 5.75882 5.4839 5.50586 6.22021 5.50586C6.95653 5.50586 7.6661 5.75882 8.20895 6.21483C8.46723 6.4329 8.67368 6.69744 8.81542 6.99194C8.95715 7.28643 9.03113 7.60455 9.03271 7.92643Z",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 1.75293H16.4696L13.8456 5.19082C14.2772 5.19081 14.7022 5.28838 15.0829 5.47489C15.4636 5.6614 15.7882 5.9311 16.028 6.26009C16.2679 6.58908 16.4155 6.96721 16.4578 7.36099C16.5001 7.75476 16.4358 8.15203 16.2707 8.51759C16.1055 8.88316 15.8445 9.20574 15.5108 9.45676C15.1772 9.70778 14.7811 9.8795 14.3577 9.95669C13.9344 10.0339 13.4968 10.0142 13.0837 9.89933C12.6707 9.78447 12.2949 9.578 11.9897 9.29821",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3455 13.2529L12.5955 16.0967L7.84546 13.6592L3.09546 16.5029",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkLineIc);
export default __webpack_public_path__ + "static/media/SparkLineIC.e6ecb41f7b984db1f2b880763e102bfd.svg";
export { ForwardRef as ReactComponent };